import { render, staticRenderFns } from "./ReportClientele.vue?vue&type=template&id=4d97a16a&scoped=true&"
import script from "./ReportClientele.vue?vue&type=script&lang=js&"
export * from "./ReportClientele.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d97a16a",
  null
  
)

export default component.exports